<template>
  <vs-popup
    class="popup"
    button-close-hidden
    v-bind="$attrs"
    v-on="$listeners"
    :style="{ zIndex: zIndex }"
  >
    <h3
      v-if="isTitleOnTop"
      class="vs-popup--title-on-top"
    >
      {{ title }}
    </h3>
    <img
      class="vs-popup--close-button"
      :src="require('@/assets/shipo-popup-icon-close.svg')"
      @click="$emit('close')"
      alt="close"
    >
    <img
      alt="Illustration"
      v-if="!hideIllustration"
      class="vs-popup--img"
      :src="require(`@/assets/${isWarning ? 'shipo-popup-icon-terminate.svg' : 'shipo-popup-icon-success.svg'}`)"
    >
    <h3 
      v-if="!isTitleOnTop"
      class="vs-popup--content-title"
    >
      {{ title }}
    </h3>
    <p :class="`${isTitleOnTop ? 'pt-12 w-full': ''}`">
      <slot />
    </p>
    <div
      v-if="isWarning"
      class="flex flex-wrap flex-row"
    >
      <vs-button
        :class="`vs-popup--ok ${!isRestore ? 'shadow-primary' : '' } ${isBusy && 'cursor-not-allowed animate-bounce'}`"
        color="primary"
        :disabled="isBusy"
        :type="`${!isRestore ? 'filled' : 'border' }`"
        @click="$emit('leftButton')"
      >
        {{ leftButton }}
      </vs-button>
      <vs-button
        :class="`vs-popup--ok ml-5 ${isRestore ? 'shadow-primary' : '' } ${isBusy && 'cursor-not-allowed animate-bounce'}`"
        color="primary"
        :disabled="isBusy"
        :type="`${isRestore ? 'filled' : 'border' }`"
        @click="$emit('rightButton')"
      >
        {{ rightButton }}
      </vs-button>
    </div>
    <vs-button
      v-if="!hideOkButton"
      class="vs-popup--ok shadow-primary"
      color="primary"
      @click="$emit('ok')"
    >
      Ok
    </vs-button>
  </vs-popup>
</template>

<script>
export default {
  name: 'PopUp',
  props: {
    title: {
      type: String,
      default: () => 'Successfully'
    },
    leftButton: {
      type: String,
      default: () => ''
    },
    rightButton: {
      type: String,
      default: () => ''
    },
    isWarning: {
      type: Boolean,
      default: () => false
    },
    isRestore: {
      type: Boolean,
      default: () => false
    },
    hideIllustration: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: () => 1000
    },
    hideOkButton: {
      type: Boolean,
      default: true
    },
    isTitleOnTop: {
      type: Boolean,
      default: true
    },
    isBusy: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  /deep/.vs-popup {
    @apply w-auto;
    @apply rounded-2xl;
    min-width: 25rem;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply relative;
      @apply p-12;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply h-full;
      @apply w-full;
      @apply items-center;

      &-title {
        @apply text-2xl;
        @apply font-semibold;
        @apply text-grey;
        @apply mt-8;
      }
    }

    &--img {
      width: 152px;
    }

    &--close-button {
      @apply cursor-pointer;
      @apply absolute;
      width: 35px;
      top: 1rem;
      right: 1rem;
    }

    &--title-on-top {
      @apply absolute;
      width: 90%;
      top: 1.5rem;
      left: 1rem;
      font-weight: 600;
      font-size: 1.5rem;
    }

    &--ok {
      @apply rounded-xl;
      @apply border-2;
      @apply mt-20;
      @apply py-4;
      @apply min-w-button;
      @apply font-semibold;
      height: calc( 1rem * 10 / 3 );

      &.shadow-secondary {
        -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
        box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
      }

      &:focus {
        @apply outline-none;
        @apply border-none;
      }
    }

    p {
      @apply text-base;
      @apply text-grey-001;
    }
  }
}
</style>
